export * from './lib/sales-feature-shell.module';
export * from './lib/sales-feature-shell-router.module';
export * from './lib/components/sales-app.component';
